import * as Yup from 'yup';
import { t } from 'i18next';

export const DrawerModalSchema = () => Yup.object().shape({
    idCart: Yup.string()
        .required(t('validation.required')),
});
